import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "icon"];
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function IconCell(_ref) {
  var size = _ref.size,
    icon = _ref.icon,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var Component = icon.type;
  return /*#__PURE__*/_jsx(Component, _extends({
    size: "md"
  }, restProps));
}
IconCell.displayName = "IconCell";
export default IconCell;